module.exports = __webpack_public_path__ + "static/media/13_andinvainthedreamer.1aeadc11.jpg";